import api from '.';

export function listar({ start = 0, size = 10, filters = '[]', filtersMode = '{}', globalFilter = '', sorting = '[]' } = {}) {
    return api.get('/unidadeCondominial/listar', {
        params: {
            start,
            size,
            filters,
            filtersMode,
            globalFilter,
            sorting,
        },
    });
}

export function consultar(uuid) {
    return api.get(`/unidadeCondominial/editar/${uuid}`);
}

export function cadastrar(dados) {
    return api.post('/unidadeCondominial/cadastrar', dados);
}

export function editar(uuid, dados) {
    return api.post('/unidadeCondominial/editar', {
        ...dados,
        uuid,
    });
}

export function excluir(uuid) {
    return api.post('/unidadeCondominial/deletar', {
        id: uuid,
    });
}

export function imprimir(url, obj = {}) {
    return api.post(`/unidadeCondominial/imprimir/?${url.toString()}`, obj, { responseType: 'arraybuffer' });
}

export function operacoesCobranca(empresaId) {
    return api.get('/unidadeCondominial/cobranca/operacoes', { params: { empresaId } });
}

export function previaCobranca(params) {
    return api.get('/unidadeCondominial/cobranca/previa', { params });
}

export function gerarCobranca(dados) {
    return api.post('/unidadeCondominial/cobranca/gerar', dados);
}
export function historicoCobranca(params) {
    return api.get('/unidadeCondominial/cobranca/historico', { params });
}
export function regularizarCobranca(dados) {
    return api.post('/unidadeCondominial/cobranca/regularizar', dados);
}
